import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import SupportBannerPc from '@/components/SupportCommon/SupportBanner';
import SupportBannerH5 from '@/componentsH5/SupportCommon/SupportBanner';
import Crum from '@/components/Crum';
import Progress from '@/components/calculators/solarpanels/OldVersion/Progress';
import Step1 from '@/components/calculators/solarpanels/OldVersion/Step1';
import Step2 from '@/components/calculators/solarpanels/OldVersion/Step2';
import Step3 from '@/components/calculators/solarpanels/OldVersion/Step3';
import { EFCalculateIcon1, EFCalculateIcon2 } from '@/components/UI/svg/Calculate';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { useSelectInfo } from '@/components/calculators/solarpanels/OldVersion/hooks';
import { getProductShopifyPrice } from '@/service';
import { ICalcSolarProps, ICalcRawData, IProductItem, ICalcRecommendProduct } from '@/components/calculators/solarpanels/OldVersion/cacl';
import seoconfig from '@/seoconfig/calculators/solarpanels';
import SEOlinksA from '@/components/SEOlinksA';
import { NEW_VISION_SITE } from '@/constants/solar-calculator';
import SolarCalcPC from '@/components/calculators/solarpanels/NewVersion';
import SolarCalcH5 from '@/componentsH5/calculators/solar-panels';

export default function SolarPanelCalc({ calcData, shopifyPriceMap, SEO }: ICalcSolarProps) {
    const { useEffect, isMobile, useLang, useRouter, useState } = useGlobal();
    const { t: t1 } = useLang('shared');
    const { t } = useLang('calculatorssolarpanels');
    const router = useRouter();
    const { locale = 'us', query } = router;
    const { step: pageStep } = query;
    const SupportBanner = isMobile ? SupportBannerH5 : SupportBannerPc;
    const [selectInfo, setSelectInfo] = useSelectInfo();
    const [isClient, setIsClient] = useState(false);
    const Layout = isMobile ? SolarCalcH5 : SolarCalcPC;
    const breadcrumbData = [
        { name: t1('crums.crum_home'), link: '/' },
        {
            name: t('calc_crum2_text'),
            link: locale === 'us' ? 'https://us.ecoflow.com/pages/solar-generators' : `https://${locale}.ecoflow.com/pages/solar-panels`,
        },
        { name: t('calc_crum3_text') },
    ];
    const bannerImgPath = isMobile ? '/h5img/calculate/solarpanels/kv.jpg' : '/img/calculate/solarpanels/kv.jpg';

    const progressata = [
        { key: 'productkey', label: 'Select Device', selectStep: '1' },
        { key: 'chargTime', label: 'Charging Time', selectStep: '2' },
        { key: 'solarType', label: 'Type', selectStep: '3' },
    ];
    const solarTypeList = [
        {
            text: t('cacl_step2_type_protable_text'),
            icon: <EFCalculateIcon1 />,
            type: 'portable',
        },
        {
            text: t('cacl_step2_type_high_text'),
            icon: <EFCalculateIcon2 />,
            type: 'high',
        },
    ];

    useEffect(() => {
        // 矫正下 selectStep
        if (!pageStep) {
            setSelectInfo({ ...selectInfo, activeStep: 1 });
        } else if (pageStep === '2') {
            const activeStep = selectInfo.solarType ? 3 : 2;
            setSelectInfo({ ...selectInfo, activeStep });
        } else if (pageStep === '3') {
            setSelectInfo({ ...selectInfo, activeStep: 4 });
        } else {
            router.replace(`/${locale}/calculators/solarpanels`);
        }
        setIsClient(true);
    }, []);
    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc') || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <PageLayout>
                <div className={css.calc_solarpanel}>
                    <SupportBanner
                        isSearch={false}
                        title={t('calc_page_title')}
                        subTitle={t('calc_page_subtitle')}
                        subTitleShow={NEW_VISION_SITE.includes(locale)}
                        isWebp={NEW_VISION_SITE?.includes(locale)}
                        webpSrc={NEW_VISION_SITE?.includes(locale) ? require(`@publicLocal/solar-calculator/${isMobile ? 'h5' : 'pc'}/kv.webp`) : ''}
                        bgImages={NEW_VISION_SITE?.includes(locale) ? require(`@publicLocal/solar-calculator/${isMobile ? 'h5' : 'pc'}/kv.jpg`) : bannerImgPath}
                    />
                    {/* 面包屑 */}
                    <Crum data={breadcrumbData} />
                    {/* 计算器 */}
                    {!NEW_VISION_SITE.includes(locale) && (
                        <div className="calc-content">
                            {isClient && (
                                <Progress
                                    data={progressata}
                                    productList={calcData.productList}
                                    solarTypeList={solarTypeList}
                                    setSelectInfo={setSelectInfo}
                                    selectInfo={selectInfo}
                                />
                            )}

                            <div className={`border step${pageStep ? pageStep : ''}`}></div>
                            {!pageStep && isClient && <Step1 productList={calcData.productList} setSelectInfo={setSelectInfo} selectInfo={selectInfo} />}
                            {pageStep === '2' && isClient && (
                                <Step2 productList={calcData.productList} solarTypeList={solarTypeList} setSelectInfo={setSelectInfo} selectInfo={selectInfo} />
                            )}
                            {pageStep === '3' && isClient && (
                                <Step3
                                    productList={calcData.productList}
                                    solarList={calcData.solarList}
                                    shopifyPriceMap={shopifyPriceMap}
                                    setSelectInfo={setSelectInfo}
                                    selectInfo={selectInfo}
                                />
                            )}
                        </div>
                    )}
                    {NEW_VISION_SITE.includes(locale) && <Layout />}
                </div>
            </PageLayout>
        </>
    );
}
export async function getServerSideProps({ locale }: any) {
    // if (!isReadyLang(locale) || ['de'].includes(locale)) {
    if (!['us', 'au', 'ca', 'uk', 'za', 'eu'].includes(locale)) {
        return redirectTo404();
    }
    let getCalcData = null;
    try {
        getCalcData = require(`@/data/calculators/solarpanels/${locale}`);
    } catch (e) {
        getCalcData = require(`@/data/calculators/solarpanels/us`);
    }
    const calcData = getCalcData(locale) as ICalcRawData;
    const { productList } = calcData;
    const allProducts = productList.reduce<IProductItem[]>((p, c) => p.concat(c.list), []);
    const allBoundles = allProducts.reduce<ICalcRecommendProduct[]>((p, c) => p.concat(c.calcRecommendProducts, c.calcBestSalesProducts), []);
    const variantIds = allBoundles.map((solar) => solar.bundleVariId).filter((id) => !!id);

    let shopifyPriceMap = {};
    const res = await getProductShopifyPrice({ variantIds: variantIds.join() });
    if (res?.code === '0') {
        shopifyPriceMap = res.data;
    }

    return {
        props: {
            calcData,
            shopifyPriceMap,
        },
        //revalidate: Number(process.env.NEXT_PUBLIC_CACHE_HOME),
    };
}
